var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6256 0.564685C6.77872 0.255782 7.22112 0.255782 7.37423 0.564686L9.11098 4.06849C9.17178 4.19116 9.28931 4.27618 9.42527 4.29585L13.3087 4.85771C13.6511 4.90725 13.7878 5.32617 13.5401 5.56662L10.73 8.29395C10.6316 8.38943 10.5867 8.527 10.6099 8.66183L11.2733 12.5129C11.3318 12.8524 10.9739 13.1113 10.6676 12.951L7.19416 11.1328C7.07256 11.0691 6.92728 11.0691 6.80568 11.1328L3.3322 12.951C3.02596 13.1113 2.66806 12.8524 2.72654 12.5129L3.38992 8.66183C3.41314 8.527 3.36825 8.38943 3.26987 8.29395L0.459764 5.56662C0.212018 5.32617 0.348728 4.90725 0.691104 4.85771L4.57457 4.29585C4.71053 4.27618 4.82806 4.19116 4.88886 4.06849L6.6256 0.564685Z",
    fill: "#65D83C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSmall);
export default __webpack_public_path__ + "static/media/starSmall.8fc0e1b5751d75c9fc9fb9d0ea24d829.svg";
export { ForwardRef as ReactComponent };